export enum MessageAttachmentType {
	QUESTIONNAIRE = 'QUESTIONNAIRE',
	EDUCATION_MATERIAL = 'EDUCATION_MATERIAL',
	FILE = 'FILE',
	DOCUMENTATION_FILE = 'DOCUMENTATION_FILE',
	FORM = 'FORM',
}
